import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SITE_NAME, SITE_URL, TWITTER_HANDLE, BUSINESS, DEFAULT_SEO } from '../../config/seo';

const SEOHead = ({
    title = DEFAULT_SEO.title,
    description = DEFAULT_SEO.description,
    keywords = DEFAULT_SEO.keywords,
    canonicalPath = '/',
    ogImage = DEFAULT_SEO.ogImage,
    ogType = 'website',
    structuredData,
    noIndex = false,
    publishedTime,
    modifiedTime,
}) => {
    const canonicalUrl = `${SITE_URL}${canonicalPath}`;
    const schemas = Array.isArray(structuredData)
        ? structuredData
        : structuredData
        ? [structuredData]
        : [];

    return (
        <Helmet>
            {/* ── Core ── */}
            <html lang="en" />
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            <meta name="robots" content={noIndex ? 'noindex,nofollow' : 'index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1'} />
            <meta name="author" content={SITE_NAME} />
            <meta name="copyright" content={SITE_NAME} />
            <meta name="language" content="English" />
            <meta name="revisit-after" content="7 days" />
            <meta name="rating" content="general" />

            {/* ── Canonical ── */}
            <link rel="canonical" href={canonicalUrl} />

            {/* ── Open Graph ── */}
            <meta property="og:type" content={ogType} />
            <meta property="og:site_name" content={SITE_NAME} />
            <meta property="og:locale" content="en_IN" />
            <meta property="og:url" content={canonicalUrl} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={ogImage} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta property="og:image:alt" content={`${SITE_NAME} – Professional Laundry Services`} />
            {publishedTime && <meta property="article:published_time" content={publishedTime} />}
            {modifiedTime && <meta property="article:modified_time" content={modifiedTime} />}

            {/* ── Twitter Card ── */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content={TWITTER_HANDLE} />
            <meta name="twitter:creator" content={TWITTER_HANDLE} />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={ogImage} />
            <meta name="twitter:image:alt" content={`${SITE_NAME} – Professional Laundry Services`} />

            {/* ── Local / Geo ── */}
            <meta name="geo.region" content="IN-WB" />
            <meta name="geo.placename" content="New Town, Kolkata, West Bengal, India" />
            <meta name="geo.position" content={`${BUSINESS.geo.latitude};${BUSINESS.geo.longitude}`} />
            <meta name="ICBM" content={`${BUSINESS.geo.latitude}, ${BUSINESS.geo.longitude}`} />

            {/* ── Business contact ── */}
            <meta name="contact" content={BUSINESS.email} />
            <meta name="reply-to" content={BUSINESS.email} />

            {/* ── Structured Data ── */}
            {schemas.map((schema, i) => (
                <script key={i} type="application/ld+json">
                    {JSON.stringify(schema)}
                </script>
            ))}
        </Helmet>
    );
};

export default SEOHead;
